export const cartTableHeader  = ["Product", "Prdouct Name", "Price", "Quantity", "Action", "Total"];